import { DialogComponent, DialogOpenEvent } from '@theme/dialog';

/**
 * Generic PDP side drawer – reusable right-sheet for informational links.
 * Powers: COMPLIMENTARY SHIPPING & RETURNS, MORE DETAILS, OTHER MATERIALS,
 * and all footer drawers that use the same shell.
 *
 * @extends {DialogComponent}
 */
class PdpSideDrawerComponent extends DialogComponent {
  requiredRefs = ['dialog'];

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(DialogOpenEvent.eventName, this.#onDialogOpen);
  }

  disconnectedCallback() {
    this.removeEventListener(DialogOpenEvent.eventName, this.#onDialogOpen);
    super.disconnectedCallback();
  }

  /**
   * After showModal() + body scroll-lock, force one layout pass so the flex
   * column (header + scrollable body) resolves to a definite height on the
   * first open. Without this, some browsers leave .pdp-side-drawer__body at
   * ~0px until a later reflow (second open / animation end).
   */
  #onDialogOpen = () => {
    const dialog = this.refs.dialog;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;

    requestAnimationFrame(() => {
      if (!dialog.open) return;
      void dialog.offsetHeight;
      const inner = dialog.querySelector('.pdp-side-drawer__inner');
      const body = dialog.querySelector('.pdp-side-drawer__body');
      if (inner instanceof HTMLElement) void inner.offsetHeight;
      if (body instanceof HTMLElement) {
        void body.offsetHeight;
        // Nudge scrollport so clipped first paint becomes scrollable immediately
        if (body.scrollHeight > body.clientHeight) {
          body.scrollTop = 0;
        }
      }
    });
  };
}

if (!customElements.get('pdp-side-drawer-component')) {
  customElements.define('pdp-side-drawer-component', PdpSideDrawerComponent);
}

export { PdpSideDrawerComponent };
